import { render } from "./AlbumsCTA.vue?vue&type=template&id=7a2e5066&scoped=true"
import script from "./AlbumsCTA.vue?vue&type=script&lang=js"
export * from "./AlbumsCTA.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7a2e5066"

export default script